import { defineComponent as _defineComponent } from 'vue'
import {Offer} from '@/models/simulation/Simulation';
import {installmentTypeDictionary} from '@/modules/multiForm/shared/MultiformDictionaries';
import FpChipRadio from '@/components/inputs/FpChipRadio.vue';
import {SimulationDemand} from '@/models/Demand';
import {computed, getCurrentInstance, onMounted, ref} from 'vue';
import {debouncedAtInput} from '@/services/utils/BasicUtils';
import ScheduleTable from '@/components/calculator/schedule/schedule-table/ScheduleTable.vue';
import BankLogo from '@/components/calculator/BankLogo.vue';
import {useModalInstance} from '@/composables/useModalInstance';
import {DebouncedFunc} from 'lodash-es';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import NavigationTabs from '@/components/commons/NavigationTabs.vue';
import {ScheduleVariant} from '@/components/calculator/schedule/models/ScheduleVariant';
import {useScheduleStore} from '@/components/calculator/services/ScheduleStore';
import {usePrintout} from '@/components/calculator/printout/usePrintout';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {IMultiformDictionary} from '@/modules/multiForm/shared/IMultiformDictionary';
import {useSimulationCurrency} from '@/components/calculator/useSimulationCurrency';
import {ReferenceRateType} from '@/models/simulation/ReferenceRateType';
import ScheduleOptionsAccordion from '@/components/calculator/schedule/ScheduleOptionsAccordion.vue';
import {useInstance} from '@/composables/useInstance';
import {ProductType} from '@/commons/enums/ProductType';

type ModalData = {
  offer: Offer,
  userInput: SimulationDemand,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleModal',
  setup(__props) {

const {$errorHandler,} = useInstance();
const modal = useModalInstance<ModalData>();
const store = useSimulationStore();
const printout = usePrintout();
const scheduleStore = useScheduleStore();
const {isForeignCurrency,} = useSimulationCurrency();
const TABS_HEADERS: readonly string[] = [
  I18NGetter().useScheduleModal.WITHOUT_EARLY_PAYMENTS,
  I18NGetter().useScheduleModal.WITH_EARLY_PAYMENTS,
  I18NGetter().useScheduleModal.WITH_EARLY_PAYMENTS_REDUCED_LOAN_PERIOD,
];
const isLoading = ref<boolean>(false);
const offer = ref<Offer>(modal.modalData.offer);
const userInput = ref<SimulationDemand>(modal.modalData.userInput);

const debouncedFetchSchedule = (): DebouncedFunc<() => void> => {
  return debouncedAtInput(async() => {
    await fetchSchedule();
  });
};

const fetchSchedule = async() => {
  isLoading.value = true;
  await scheduleStore.fetchSchedule();
  isLoading.value = false;
};

const onChange: DebouncedFunc<() => void> = debouncedFetchSchedule();

const installmentType = computed<string>(() => {
  return scheduleStore.userInput?.fixedInstallments
    ? I18NGetter().useScheduleModal.FIXED_INSTALLMENT
    : I18NGetter().useScheduleModal.DESCENDING_INSTALLMENT;
});

const isScheduleWithEarlyPaymentsHidden = computed<boolean>(
  () => scheduleStore.scheduleVariant !== ScheduleVariant.WITHOUT_ADDITIONAL_PAYMENT &&
    scheduleStore.earlyPaymentSum === 0
);

const isMortgageProduct = computed(() => store.productType === ProductType.MORTGAGE);

const availableInstallmentTypes = computed<IMultiformDictionary<boolean>>(() => 
  isMortgageProduct.value
    ? (offer.value.restrictions?.onlyFixedInstallments
      ? installmentTypeDictionary.filter((type) => type.type)
      : installmentTypeDictionary)
    : []
);


onMounted(async() => {
  try {
    isLoading.value = true;
    await scheduleStore.initSchedule(offer.value, userInput.value, store.productType!);
  } catch (e) {
    $errorHanlder(e);
  } finally {
    isLoading.value = false;
  }
});

return { __sfc: true,$errorHandler, modal, store, printout, scheduleStore, isForeignCurrency, TABS_HEADERS, isLoading, offer, userInput, debouncedFetchSchedule, fetchSchedule, onChange, installmentType, isScheduleWithEarlyPaymentsHidden, isMortgageProduct, availableInstallmentTypes, FpChipRadio, ScheduleTable, BankLogo, NavigationTabs, ReferenceRateType, ScheduleOptionsAccordion }
}

})